
import getCookie from './getCookie';


const fetchServerResponse = async (endpoint) => {
    const token = getCookie("auth-cookie")

    const baseURL = process.env.REACT_APP_BASEURL;
    const url = baseURL + endpoint + '/' + token;

    const response = await fetch(url);
    if (response.ok) {

        return response.json();
    } else {

        throw new Error('Failed to fetch user data');
    }

}


export default fetchServerResponse;